import { Registry } from '@react-registry'

export const H6Deserializer = (el) => {
    return {
        type: 'h6',
    }
}

Registry.register(H6Deserializer, { id: 'H6', registry: 'deserializer' })